import React from "react";
import { XCircle, Home, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { usePaymentCore } from "@/features/payment";
import { useTranslation } from "react-i18next";

export const PaymentErrorPage: React.FC = () => {
  const { error, completePayment, clearError } = usePaymentCore();
  const { t } = useTranslation();

  const handleGoHome = () => {
    completePayment();
  };

  const handleRetry = () => {
    clearError();
    // Retry logic can be implemented here
  };

  return (
    <div className="flex flex-col items-center justify-center p-8 space-y-6">
      <div className="flex flex-col items-center space-y-4">
        <XCircle className="h-16 w-16 text-red-500" />
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
          {t("payment.error.title")}
        </h2>
        <p className="text-gray-600 dark:text-gray-400 text-center max-w-md">
          {t("payment.error.description")}
        </p>
        {error && (
          <div className="bg-red-50 dark:bg-red-900/10 border border-red-200 dark:border-red-800 rounded-lg p-4 max-w-md">
            <p className="text-sm text-red-700 dark:text-red-300">{error}</p>
          </div>
        )}
      </div>

      <div className="flex flex-col space-y-3 w-full max-w-sm">
        <Button onClick={handleRetry} variant="outline" className="w-full">
          <RefreshCw className="h-4 w-4 mr-2" />
          {t("payment.error.tryAgain")}
        </Button>
        <Button onClick={handleGoHome} className="w-full">
          <Home className="h-4 w-4 mr-2" />
          {t("payment.error.goHome")}
        </Button>
      </div>

      <div className="text-sm text-gray-500 dark:text-gray-400 text-center">
        <p>{t("support.contactSupport")}</p>
      </div>
    </div>
  );
};
